/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { applyStyle, getSmartSize } from '../../utils/helpers/styles'
import { useColor } from '../theme/_hooks/colors'

const Line = ({ height, width, vertical, color, align }) => {
  const colorValue = useColor(color, 'light2')
  const heightValue = getSmartSize(height, {}, vertical ? '100%' : '1px')
  const widthValue = getSmartSize(width, {}, !vertical ? '100%' : '1px')

  const style = css`
    height: ${heightValue};
    width: ${widthValue};
    background-color: ${colorValue};
    border-radius: ${heightValue};
    margin: 0 auto;
    ${applyStyle('margin', align === 'left', '0')}
    ${applyStyle('margin-right', align === 'right', '0')}
  `

  return <div className="line" css={style} />
}

export default Line
